import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_IMAGE_SIZE, type Crop } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CroppedMockupProps = {
  crop: Crop;
  alt: string;
  className?: string;
};
export function CroppedMockup({
  crop,
  alt,
  className = ''
}: CroppedMockupProps) {
  const {
    width,
    height
  } = PRODUCT_IMAGE_SIZE;
  return <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} aria-label={`${alt} — comprar el sistema completo`} className={`relative block overflow-hidden rounded-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${className}`} style={{
    aspectRatio: `${crop.w} / ${crop.h}`
  }} data-id="element-25" data-mp="v1z9z2nq3y5e">
      <img src={PRODUCT_IMAGE} alt={alt} className="absolute max-w-none" style={{
      width: `${width / crop.w * 100}%`,
      height: `${height / crop.h * 100}%`,
      left: `${-(crop.x / crop.w) * 100}%`,
      top: `${-(crop.y / crop.h) * 100}%`
    }} data-id="element-26" data-mp="genx8xft283p" />
    </a>;
}